export const pasteErrorText =
  "Your browser doesn't allow pasting clipboard content via button. Please use shortcut instead.";

export const shortcut = { hotKey: 'CTRL/Cmd + V', label: 'for paste' };

export const error = {
  message: 'Error Message',
  close: 'Close',
};
